<template>
  <path
    d="M19.35 10.0402C18.67 6.59024 15.64 4.00024 12 4.00024C9.11 4.00024 6.6 5.64024 5.35 8.04024C2.34 8.36024 0 10.9102 0 14.0002C0 17.3102 2.69 20.0002 6 20.0002H19C21.76 20.0002 24 17.7602 24 15.0002C24 12.3602 21.95 10.2202 19.35 10.0402Z"
  />
</template>
